var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeckOrThroat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "14px",
    viewBox: "0 0 25 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Neck or Thoat") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Humanuculus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.195858829
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-9",
    transform: "translate(-76.000000, -73.000000)",
    fill: "#1E428A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.6361675,73.0195276 L101,73 C97.9403475,75.800393 96.4105212,78.0099252 96.4105212,79.6285965 C96.4105212,81.2472678 97.4553954,83.7044023 99.5451439,87 L77,87 C79.2297308,83.7345317 80.3445962,81.2773972 80.3445962,79.6285965 C79.6378853,77.8811646 78.4017424,75.6781416 76.6361675,73.0195276 Z",
    id: "Neck-or-Thoat"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeckOrThroat);
export default __webpack_public_path__ + "static/media/NeckOrThroat.a4eb8d31ee9d2ee93d336d88683ae615.svg";
export { ForwardRef as ReactComponent };